import { createEffect } from "effector"
import { catchError, lastValueFrom } from "rxjs"
import { HttpService } from "@callcenter/services"

import type { UserAccountFormState } from "../shared/types"
import type { UserAccountFormError } from "./types"

type SavePayload = {
  interface_language: UserAccountFormState["interface_language"]
  agent_workspace_display_layout: UserAccountFormState["agent_workspace_display_layout"]
  current_password: UserAccountFormState["current_password"]
  password: UserAccountFormState["password"]
  password_confirmation: UserAccountFormState["password_confirmation"]
  translate_from_languages: UserAccountFormState["translate_from_languages"]
  translate_to_language: UserAccountFormState["translate_to_language"]
  transcript_translation_enabled: UserAccountFormState["transcript_translation_enabled"]
}

export const userProfileSaveFx = createEffect<UserAccountFormState, UserAccountFormState, UserAccountFormError>(
  (payload) => {
    const data: Partial<SavePayload> = {
      interface_language: payload.interface_language
    }

    if (payload.agent_workspace_display_layout) {
      data.agent_workspace_display_layout = payload.agent_workspace_display_layout
    }

    if (payload.current_password || payload.password || payload.password_confirmation) {
      data.current_password = payload.current_password
      data.password = payload.password
      data.password_confirmation = payload.password_confirmation
    }

    if (payload.is_transcript_translation_enabled) {
      data.transcript_translation_enabled = payload.transcript_translation_enabled
    }

    if (payload.transcript_translation_enabled) {
      data.translate_from_languages = payload.translate_from_languages?.length
        ? payload.translate_from_languages
        : payload.available_languages?.filter((language) => language !== payload.translate_to_language)
      data.translate_to_language = payload.translate_to_language
    }

    return lastValueFrom(
      HttpService.put<
        UserAccountFormState,
        {
          current_user: Partial<SavePayload>
        }
      >("/users/profile", {
        current_user: {
          ...data
        }
      }).pipe(catchError((error) => Promise.reject(error.errors)))
    )
  }
)
